import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import IntegrationItem from './IntegrationItem';
import { INTEGRATIONS_CONFIG } from 'config/integrationsConfig';
import { getIconComponent } from '../../utils/icons/iconUtils';
import { HelpOutlineIcon } from 'icons/materialIcons';

const CRMContainer = ({ searchTerm = '' }) => {
    const filteredIntegrations = INTEGRATIONS_CONFIG.CRM.filter(integration =>
        integration.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Only show the "Don't see your integration" option when not searching or when the search matches it
    const showRequestOption = !searchTerm || 'don\'t see your integration'.includes(searchTerm.toLowerCase());

    if (filteredIntegrations.length === 0 && !showRequestOption && searchTerm) {
        return null;
    }

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    mb: 3,
                    color: '#242020'
                }}
            >
                CRM
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    mb: 3,
                    color: '#828282'
                }}
            >
                Sync Touch leads to your CRM
            </Typography>
            <Grid container spacing={2}>
                {filteredIntegrations.map((integration) => (
                    <Grid item xs={12} sm={6} md={3} key={integration.name}>
                        <IntegrationItem
                            text={integration.name}
                            icon={getIconComponent(integration.name)}
                            disabled={integration.disabled}
                            comingSoon={integration.comingSoon}
                        />
                    </Grid>
                ))}

                {/* Request integration option */}
                {showRequestOption && (
                    <Grid item xs={12} sm={6} md={3}>
                        <IntegrationItem
                            text={
                                <Box>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                                        Don't see your integration?
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#818181' }}>
                                        Request one here
                                    </Typography>
                                </Box>
                            }
                            icon={<HelpOutlineIcon sx={{ color: '#29AEF8' }} />}
                        />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default CRMContainer;